import type { party_enum } from '@vrplatform/graphql';
import { useMemo } from 'react';
import { useTaxRatesQuery } from '@vrplatform/data';

type Props = {
  centTotal: number;
  markup: number;
  taxId: string | null;
  markupTaxId: string | null;
  party: party_enum;
  rates: NonNullable<ReturnType<typeof useTaxRatesQuery>['data']>;
};

export const getExpenseLineCentTotal = ({
  centTotal,
  markup: m,
  taxId,
  markupTaxId,
  party,
  rates,
}: Props) => {
  const appliedRate = taxId ? rates.find((x) => x.value === taxId) : undefined;
  const markupRate = markupTaxId
    ? rates.find((x) => x.value === markupTaxId)
    : undefined;

  const appliedAmountTax = appliedRate
    ? (appliedRate.percentageSuperBasePoints / 100000) * centTotal
    : 0;
  const appliedAmount = centTotal + appliedAmountTax;

  const markup = party === 'owners' ? m || 0 : 0;
  const markupTax = markupRate
    ? (markupRate.percentageSuperBasePoints / 100000) * markup
    : 0;

  return {
    centTotal: appliedAmount + markup + markupTax,
    appliedRate,
    markupRate,
  };
};

export function useExpenseLineCentTotal(props: Omit<Props, 'rates'>) {
  const { data: rates, error, isLoading: loading } = useTaxRatesQuery();

  const data = useMemo(
    () => getExpenseLineCentTotal({ ...props, rates: rates ?? [] }),
    [props, rates]
  );

  return {
    data: loading ? undefined : data,
    loading,
    error,
  };
}
